import { render } from "./errorData.vue?vue&type=template&id=1875c430"
import script from "./errorData.vue?vue&type=script&lang=js"
export * from "./errorData.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__